import { IColumnsList } from "src/app/shared/domains/user/columns.hook";
import { NullableArraySchema } from "yup";
import { MpAutonomousCreateData } from "./mrpAutonomousCreate.component";

// Punchout Catalog Table Columns

export enum MrpAutonousSourcingTableColumns {
  COMPANY_CODE = "Company Code",
  PURCHASING_ORGANIZATION = "Purchasing Organization*",
  PLANT = "Plant",
  SPEND_CATEGORY = "Spend Category",
  FIXED_ID = "Fixed ID",
  MRP_CONTROLLER = "MRP Controler",
  PURCHASE_GROUP = "P Group",
  TAX_CODE = "Tax Code",
  BUYER = "Buyer*",
  DOC_TYPE = "Doc Type",
  MATERIAL_TYPE = "Material Type"
}

export function DefaultMrpAutonousSourcingColumns() {
  return [
    {
      id: MrpAutonousSourcingTableColumns.COMPANY_CODE,
      show: true,
      hidden: false
    },
    {
      id: MrpAutonousSourcingTableColumns.PURCHASING_ORGANIZATION,
      show: true,
      hidden: false
    },
    {
      id: MrpAutonousSourcingTableColumns.PLANT,
      show: true,
      hidden: false
    },
    {
      id: MrpAutonousSourcingTableColumns.SPEND_CATEGORY,
      show: true,
      hidden: false
    },
    { id: MrpAutonousSourcingTableColumns.FIXED_ID, show: true, hidden: false },
    {
      id: MrpAutonousSourcingTableColumns.MRP_CONTROLLER,
      show: true,
      hidden: false
    },
    {
      id: MrpAutonousSourcingTableColumns.PURCHASE_GROUP,
      show: true,
      hidden: false
    },
    { id: MrpAutonousSourcingTableColumns.TAX_CODE, show: true, hidden: false },
    { id: MrpAutonousSourcingTableColumns.BUYER, show: true, hidden: false },
    { id: MrpAutonousSourcingTableColumns.DOC_TYPE, show: true, hidden: false },
    {
      id: MrpAutonousSourcingTableColumns.MATERIAL_TYPE,
      show: true,
      hidden: false
    }
  ];
}

export interface MrpAutonousSourcingList extends IColumnsList {
  id: MrpAutonousSourcingTableColumns;
}

export function GetMrpAutonousSourcingColumns(
  columns?: MrpAutonousSourcingList[]
): MrpAutonousSourcingList[] {
  return columns?.length > 0 ? columns : DefaultMrpAutonousSourcingColumns();
}

export interface FromNetworkMrpAutonousSourcingDataDTO {
  id: string;
  pOrg: string;
  companyCode: string;
  plant: string;
  docType: string[];
  materialType: string[];
  spendCategory: string[];
  mrpController: string[];
  fixedId: string[];
  systemAlias: string | null;
  buyerEmail: string[];
  userId: string | null;
  purchaseGroup: string[];
  taxCode: string | null;
}

export class MrpAutonousSourcingData {
  constructor(
    public readonly id: string,
    public readonly pOrg: string,
    public readonly companyCode: string,
    public readonly plant: string,
    public readonly docType: string[],
    public readonly materialType: string[],
    public readonly spendCategory: string[],
    public readonly mrpController: string[],
    public readonly fixedId: string[],
    public readonly systemAlias: string | null,
    public readonly buyerEmail: string[],
    public readonly userId: string | null,
    public readonly purchaseGroup: string[],
    public readonly taxCode: string | null
  ) {}

  static FromBackend(
    data: FromNetworkMrpAutonousSourcingDataDTO
  ): MrpAutonousSourcingData {
    return new MrpAutonousSourcingData(
      data.id,
      data.pOrg,
      data.companyCode,
      data.plant,
      data.docType,
      data.materialType,
      data.spendCategory,
      data.mrpController,
      data.fixedId,
      data.systemAlias,
      data.buyerEmail,
      data.userId,
      data.purchaseGroup,
      data.taxCode
    );
  }
}

export const CategoryOptions = [
  {
    value: "S21",
    label: "S21"
  },
  {
    value: "S22",
    label: "S22"
  },
  {
    value: "S24",
    label: "S24"
  },
  {
    value: "S25",
    label: "S25"
  }
];

export const MaterialTypeOptions = [
  {
    value: "ERSA",
    label: "ERSA"
  },
  {
    value: "UNBW",
    label: "UNBW"
  },
  {
    value: "NLAG",
    label: "NLAG"
  }
];

export const DocTypeOptions = [
  {
    value: "NB",
    label: "NB"
  },
  {
    value: "Z008",
    label: "Z008"
  },
  {
    value: "NB - Standard",
    label: "NB - Standard"
  },
  {
    value: "Z001",
    label: "Z001"
  },
  {
    value: "Z008",
    label: "Z008"
  }
];

export const initialMrpAutonomousData: MpAutonomousCreateData = {
  id: null,
  pOrg: "",
  companyCode: "",
  plant: "",
  docType: ["NB", "Z008"],
  materialType: ["ERSA", "UNBW", "NLAG "],
  spendCategory: ["S21", "S22", "S24", "S25"],
  mrpController: [],
  systemAlias: "",
  buyerEmail: [],
  taxCode: "",
  userId: ""
};

export const defaultAutonomousFiltersData = {
  companyCode: {
    data: [],
    key: "companyCode",
    label: "Company Code",
    selected: []
  },
  purchasingOrganization: {
    data: [],
    key: "purchasingOrganization",
    label: "Purchasing Organization",
    selected: []
  },
  purchasingGroup: {
    data: [],
    key: "purchasingGroup",
    label: "Purchasing Group",
    selected: []
  },
  plant: {
    data: [],
    key: "plant",
    label: "Plant",
    selected: []
  },
  buyer: {
    data: [],
    key: "buyer",
    label: "Buyer",
    selected: []
  },
  category: {
    data: [],
    key: "category",
    label: "Category",
    selected: []
  },
  materialType: {
    data: [],
    key: "materialType",
    label: "Material Type",
    selected: []
  },
  docType: {
    data: [],
    key: "docType",
    label: "DocType",
    selected: []
  },
  taxCode: {
    data: [],
    key: "taxCode",
    label: "TaxCode",
    selected: []
  },
  systemAlias: {
    data: [],
    key: "systemAlias",
    label: "SystemAlias",
    selected: []
  },
  userId: {
    data: [],
    key: "userId",
    label: "UserId",
    selected: []
  },
  mrpControllerFrom: {
    data: [],
    key: "mrpControllerFrom",
    label: "Mrp Controller From",
    selected: null
  },
  mrpControllerTo: {
    data: [],
    key: "mrpControllerTo",
    label: "Mrp Controller To",
    selected: null
  }
};

export enum MrpAutonomousFilterKeys {
  COMPANY_CODE = "companyCode",
  PURCHASING_ORGANIZATION = "purchasingOrganization",
  PURCHASE_GROUP = "purchasingGroup",
  PLANT = "plant",
  BUYER = "buyer",
  CATEGORY = "category",
  USERID = "userId",
  DOCTYPE = "docType",
  TAXCODE = "taxCode",
  SYSTEMALIAS = "systemAlias",
  MATERIAL_TYPE = "MaterialType",
  MRPCONTROLLERFROM = "mrpControllerFrom",
  MRPCONTROLLERTO = "mrpControllerTo"
}

export const MrpAutonomousFilter = [
  { key: MrpAutonomousFilterKeys.COMPANY_CODE, label: "Company Code" },
  {
    key: MrpAutonomousFilterKeys.PURCHASING_ORGANIZATION,
    label: "Purchasing Organization"
  },
  { key: MrpAutonomousFilterKeys.PURCHASE_GROUP, label: "Purchase Group" },
  { key: MrpAutonomousFilterKeys.PLANT, label: "Plant" },
  { key: MrpAutonomousFilterKeys.MATERIAL_TYPE, label: "Material Type" },
  {
    key: MrpAutonomousFilterKeys.MRPCONTROLLERTO,
    label: "MRP Controller To"
  },
  {
    key: MrpAutonomousFilterKeys.MRPCONTROLLERFROM,
    label: "MRP Controller From"
  },
  { key: MrpAutonomousFilterKeys.BUYER, label: "BUYER" },
  { key: MrpAutonomousFilterKeys.CATEGORY, label: "CATEGORY" },
  { key: MrpAutonomousFilterKeys.USERID, label: "User ID" },
  { key: MrpAutonomousFilterKeys.DOCTYPE, label: "Doc Type" },
  { key: MrpAutonomousFilterKeys.TAXCODE, label: "Tax Code" },
  { key: MrpAutonomousFilterKeys.SYSTEMALIAS, label: "System Alias" }
];

export const templatePayloadForBE = (filters: any) => {
  let body = {
    companyCode: filters.companyCode.selected,
    purchasingOrganization: filters.purchasingOrganization.selected,
    purchasingGroup: filters.purchasingGroup.selected,
    plant: filters.plant.selected,
    materialType: filters.materialType.selected,
    buyer: filters.buyer.selected,
    category: filters.category.selected,
    docType: filters.docType.selected,
    taxCode: filters.taxCode.selected,
    systemAlias: filters.systemAlias.selected,
    userId: filters.userId.selected,
    mrpControllerFrom: filters.mrpControllerFrom.selected,
    mrpControllerTo: filters.mrpControllerTo.selected
  };
  return body;
};
